import * as React from "react";
type Props = {
  className?: string,
};
function SvgBreakfast2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-breakfast2"
      className={className}
    >
      <g id="breakfast">
        <path
          id="Vector"
          d="M21.9496 2.72004C21.9496 2.72004 4.54957 2.78004 1.15957 14.56C1.15957 14.56 0.0995679 17.9 2.09957 19.84C5.37957 29.99 36.9196 32.06 37.0196 11.66C37.0496 6.78004 30.9496 2.18004 21.9496 2.72004Z"
          fill="#F0CA9E"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <g id="Vector_2">
          <path
            d="M2 19.74C8.37 23.3 20.85 23.94 27.75 20.94C29.48 20.19 34.76 17.73 36.96 12.77"
            fill="#F9E5D4"
          />
          <path
            d="M2 19.74C8.37 23.3 20.85 23.94 27.75 20.94C29.48 20.19 34.76 17.73 36.96 12.77"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </g>
        <path
          id="Vector_3"
          d="M0.699786 17.5399C0.739786 20.2699 5.37979 20.3599 9.65979 20.3599C13.2198 20.3599 16.7598 21.8899 21.3898 20.9599C25.6098 20.1299 25.9298 18.3499 31.8998 16.8899C35.2098 16.0799 37.6998 11.8299 37.1198 8.93987C36.5998 6.32987 35.4198 2.88987 30.2698 2.74987C25.2098 2.61987 21.1698 1.46987 16.4098 2.40987C11.8998 3.30987 6.96979 4.17987 5.21979 7.22987C3.14979 10.8699 0.639786 12.4999 0.699786 17.5399ZM21.0198 7.12987C26.3398 7.36987 25.2698 10.5299 25.2698 10.5299C24.0698 14.3299 18.5098 14.4899 18.5098 14.4899C15.5198 14.7099 13.3198 13.3499 13.2298 11.7299C12.9298 7.03987 21.0198 7.12987 21.0198 7.12987Z"
          fill="white"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <g id="Group">
          <path
            id="Vector_4"
            d="M10.0202 3.49983C7.76017 3.53983 5.96017 5.06983 6.00017 6.90983C6.00017 7.09983 6.00017 7.86983 6.01017 8.07983C6.04017 9.91983 7.90017 11.3798 10.1502 11.3398C12.4002 11.2998 14.2002 9.76983 14.1702 7.92983C14.1702 7.73983 14.1702 6.96983 14.1602 6.75983C14.1202 4.91983 12.2702 3.45983 10.0202 3.49983Z"
            fill="#438442"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_5"
            d="M10.1419 10.1591C12.3948 10.1168 14.193 8.59182 14.1585 6.75307C14.1239 4.91433 12.2696 3.45808 10.0167 3.50044C7.76381 3.54281 5.96553 5.06774 6.0001 6.90648C6.03468 8.74522 7.88902 10.2015 10.1419 10.1591Z"
            fill="#E6F4E6"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_6"
            d="M10.2102 7.52002L10.2002 8.56002"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_7"
            d="M9.19023 7.0498L8.24023 7.4698"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_8"
            d="M12.1402 7.38977L11.1802 7.00977"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_9"
            d="M9.65996 6.12963L8.95996 5.36963"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_10"
            d="M11.45 5.31006L10.79 6.11006"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_2">
          <path
            id="Vector_11"
            d="M25.8095 1.01979C23.5895 1.40979 22.0495 3.18979 22.3595 4.99979C22.3895 5.17979 22.5095 5.93979 22.5495 6.14979C22.8695 7.95979 24.9195 9.11979 27.1395 8.73979C29.3595 8.34979 30.8995 6.56979 30.5895 4.75979C30.5595 4.57979 30.4395 3.81979 30.3995 3.60979C30.0895 1.78979 28.0295 0.63979 25.8095 1.01979Z"
            fill="#438442"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_12"
            d="M26.9507 7.59064C29.1707 7.20442 30.7148 5.4225 30.3995 3.61061C30.0843 1.79872 28.0291 0.642984 25.8092 1.0292C23.5892 1.41542 22.0451 3.19734 22.3603 5.00923C22.6755 6.82112 24.7307 7.97686 26.9507 7.59064Z"
            fill="#E6F4E6"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_13"
            d="M26.6196 4.96973L26.7696 5.98973"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_14"
            d="M25.5299 4.65967L24.6699 5.21967"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_15"
            d="M28.4997 4.53982L27.4897 4.31982"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_16"
            d="M25.8598 3.66979L25.0498 3.02979"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_17"
            d="M27.4997 2.59961L26.9697 3.47961"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_18"
            d="M30.5 7.79968C28.29 8.22968 26.78 10.0397 27.13 11.8497C27.17 12.0297 27.3 12.7897 27.34 12.9997C27.69 14.8097 29.77 15.9297 31.98 15.4997C34.19 15.0697 35.7 13.2597 35.35 11.4497C35.31 11.2697 35.18 10.5097 35.14 10.2997C34.79 8.48968 32.72 7.37968 30.5 7.79968Z"
            fill="#438442"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_19"
            d="M31.7724 14.3494C33.9847 13.9215 35.4951 12.1109 35.1458 10.3053C34.7966 8.49962 32.72 7.38275 30.5077 7.81066C28.2954 8.23856 26.7851 10.0492 27.1343 11.8548C27.4836 13.6605 29.5601 14.7774 31.7724 14.3494Z"
            fill="#E6F4E6"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_20"
            d="M31.3799 11.73L31.5499 12.75"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_21"
            d="M30.2899 11.4399L29.4399 12.0199"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_22"
            d="M33.26 11.2701L32.25 11.0601"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_23"
            d="M30.5998 10.4498L29.7798 9.81982"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_24"
            d="M32.22 9.3501L31.71 10.2401"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_4">
          <path
            id="Vector_25"
            d="M22.7499 13.3099C20.4999 13.3499 18.6999 14.8799 18.7299 16.7199C18.7299 16.9099 18.7299 17.6799 18.7399 17.8899C18.7699 19.7299 20.6299 21.1899 22.8799 21.1499C25.1299 21.1099 26.9299 19.5799 26.8999 17.7399C26.8999 17.5499 26.8999 16.7799 26.8899 16.5699C26.8599 14.7299 25.0099 13.2699 22.7499 13.3099Z"
            fill="#438442"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_26"
            d="M22.8811 19.9794C25.134 19.9371 26.9323 18.4121 26.8977 16.5734C26.8632 14.7346 25.0088 13.2784 22.7559 13.3208C20.5031 13.3631 18.7048 14.8881 18.7394 16.7268C18.7739 18.5655 20.6283 20.0218 22.8811 19.9794Z"
            fill="#E6F4E6"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_27"
            d="M22.9499 17.3398L22.9399 18.3698"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_28"
            d="M21.92 16.8599L20.98 17.2899"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_29"
            d="M24.8799 17.2001L23.9199 16.8301"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_30"
            d="M22.3897 15.9402L21.6997 15.1802"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_31"
            d="M24.1798 15.1299L23.5298 15.9199"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_5">
          <path
            id="Vector_32"
            d="M11.8298 12.3797C9.60985 11.9897 7.54985 13.1397 7.22985 14.9597C7.19985 15.1397 7.04985 15.8997 7.00985 16.1097C6.68985 17.9197 8.22985 19.7097 10.4498 20.0997C12.6698 20.4897 14.7298 19.3397 15.0498 17.5197C15.0798 17.3397 15.2298 16.5797 15.2698 16.3697C15.5898 14.5597 14.0498 12.7697 11.8298 12.3797Z"
            fill="#438442"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_33"
            d="M15.2729 16.3637C15.5918 14.5524 14.0512 12.7673 11.8319 12.3766C9.61263 11.9858 7.55501 13.1375 7.23611 14.9488C6.91721 16.7601 8.45779 18.5453 10.6771 18.936C12.8964 19.3267 14.954 18.1751 15.2729 16.3637Z"
            fill="#E6F4E6"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_34"
            d="M11.2498 16.3599L11.0498 17.3799"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_35"
            d="M10.3396 15.6997L9.32959 15.9397"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_36"
            d="M13.1698 16.5998L12.2998 16.0498"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_37"
            d="M10.9799 14.8898L10.4399 14.0098"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_38"
            d="M12.8898 14.4297L12.0898 15.0897"
            stroke="currentColor"
            strokeWidth={0.5}
            strokeMiterlimit={10}
          />
        </g>
      </g>
    </svg>
  );
}
export default SvgBreakfast2;
